import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-3d-model",
  "use": "icon-3d-model-usage",
  "viewBox": "0 0 60 60",
  "content": "<symbol aria-hidden=\"true\" class=\"icon icon--full-color icon-3d-badge-full-color\" viewBox=\"0 0 60 60\" id=\"icon-3d-model\"><path class=\"icon-3d-badge-full-color-outline\" d=\"M.968 30C.968 46.034 13.966 59.032 30 59.032S59.032 46.034 59.032 30 46.034.968 30 .968.968 13.966.968 30z\" /><path d=\"M30 15l12.99 7.5v15L30 45l-12.99-7.5v-15L30 15z\" stroke=\"currentColor\" stroke-width=\"1.5\" /><path d=\"M30 45V29.307l1.383-.853 11.95-6.789V37.38L30 45z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol